<div class="logo-wrapper">
  <img src="assets/imgs/UoA-Logo-Primary-RGB-Large.png" alt="The University of Auckland logo" />
</div>
